import { connect } from 'react-redux';
import moment from 'moment';

import { requestFetchTvguide } from '@tvguide/store/actions/requests';
import { setChannels } from '@store/actions/channels';
import API from '@api';
import App from './App';

const mapStateToProps = state => ({
  nid: state.ux.nid,
  view: state.ux.view,
  isLoaded: state.ux.load.programs,
});

const mapDispatchToProps = dispatch => ({
  getDayProgram: nid => {
    dispatch(
      requestFetchTvguide(
        nid,
        moment
          .utc()
          .startOf('day')
          .unix(),
      ),
    );
  },
  getChannels: nid => {
    return API.getChannels(nid)
      .then(channels => {
        dispatch(setChannels(channels));
        return;
      })
      .catch(error => {
        console.error(error);
      });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
